//src/styles/components/MuiCssBaseline.js
import palette from "../palette";

const MuiCssBaseline = {
  styleOverrides: {
    body: { 
      fontFamily: "inherit", 
      fontSize: "16px", 
      backgroundColor: palette.background?.default || "#f5f5f5", 
      color: palette.text?.primary || "#333", 
      transition: "all 0.3s ease" 
    },
    a: { 
      color: palette.primary?.main || "#1976d2", 
      textDecoration: "none", 
      transition: "color 0.3s ease", 
      "&:hover": { color: palette.primary?.dark || "#115293" } 
    },
  },
};

export default MuiCssBaseline;